import { render, staticRenderFns } from "./Arrows.vue?vue&type=template&id=1035d98b&"
import script from "./Arrows.vue?vue&type=script&lang=js&"
export * from "./Arrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports